import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, ControlLabel } from "react-bootstrap";
import Select from "react-select";
import "react-select/dist/react-select.css";
import _ from "lodash";
import "./index.css";

class AlertTypeDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultAlertType: "",
      selectedAlertType: this.props.defaultValue ? this.props.defaultValue : undefined
    };
  }

  componentDidMount() {
    if (this.props.configList) {
      this.setState({
        alertTypeList: this.sortAlertTypes(this.filterAlertTypes(this.props.configList.alert_types))
      });
    }
  }

  filterAlertTypes = alertTypeList => {
    if (!alertTypeList) {
      return null;
    }

    return _.filter(alertTypeList, item => {
      return item.severity === "reportable";
    });
  };

  sortAlertTypes = alertTypeList => {
    if (!alertTypeList) {
      return null;
    }

    return _.orderBy(alertTypeList, ["name"], ["asc"]);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.list !== nextProps.list && nextProps.list) {
      this.setState({
        alertTypeList: nextProps.list
      });
    }

    if (this.props.reset !== nextProps.reset) {
      this.setState({
        selectedAlertType: ""
      });
      this.props.change("");
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedAlertType: selectedOption });
    if (selectedOption) {
      this.props.change(selectedOption.map(c => c.id));
    }
  };

  render = () => {
    if (this.state.alertTypeList) {
      return (
        <div className="precinct">
          <FormGroup controlId="formControlsSelect">
            <ControlLabel>Alert type</ControlLabel>
            <Select
              name="form-field-name"
              value={this.state.selectedAlertType}
              onChange={this.handleChange}
              valueKey="id"
              labelKey="name"
              multi={true}
              options={this.state.alertTypeList}
            />
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { configList } = state.configuration;
  const { list } = state.disciplinesList;
  return {
    user,
    configList,
    list
  };
}

export default connect(mapStateToProps)(AlertTypeDropdown);



// WEBPACK FOOTER //
// ./src/_components/AlertTypeDropdown/index.js